
<div
  :class="classes(
    n(),
    n(`--${size}`),
    [disabled, n('--disabled')],
    [!!contentValue, n('--active')],
  )"
  :aria-checked="contentValue"
  :aria-disabled="disabled"
  @click="handleClick"
>
  <div
    :class="classes(
      n(`--content`),
    )"
  >
    <div
      :class="classes(
        n('--dot')
      )"
    />
  </div>
</div>
